module.exports = __webpack_public_path__ + "static/storytimePodcast-ac385fea9209b519c9be30ba6fc005a1.jpg";